module.exports = __webpack_public_path__ + "img/2.4e00ed06.png";